// @ts-ignore
// import LoginAPI from '@ekd/login-api-client-v2/lt';
interface LoginAPI extends Window {
  LoginAPI: any;
}

declare const window: LoginAPI;

// let globalLoginApiClient: any = null;

export function loginApiClient() {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    return;
  }

  // FIX ME: Use login-api-client from nuxt.config until login-app refactor
  /*
  // Reuse client on the client-side
  if (!globalLoginApiClient) {
    globalLoginApiClient = LoginAPI;

    if (!window.LoginAPI) {
      window.LoginAPI = LoginAPI;
    }
  }
  */

  // return LoginAPI;
  return window.LoginAPI;
}
